import type { ProcessStep, Principle } from '@/types'

export const PROCESS: ProcessStep[] = [
    {
        title: "Discover",
        description: "We learn about your business, audience, competitors, and growth opportunities."
    },
    {
        title: "Strategize",
        description: "We define the marketing direction, campaign objectives, positioning, and measurement approach."
    },
    {
        title: "Create and launch",
        description: "We develop creative concepts, produce campaign assets, and execute across relevant marketing channels."
    },
    {
        title: "Optimize",
        description: "We analyze performance, identify opportunities, and improve campaign effectiveness."
    }
]

export const PRINCIPLES: Principle[] = [
    {
        title: "Strategy before execution",
        description: "Every campaign starts with a clear understanding of the business objective."
    },
    {
        title: "Creativity with purpose",
        description: "Every idea should connect with an audience and support a meaningful goal."
    },
    {
        title: "Results that matter",
        description: "We use performance insights to understand what works and identify opportunities for improvement."
    }
]

export const BUDGETS: string[] = [
    "Under $10k",
    "$10k to $25k",
    "$25k to $50k",
    "$50k to $100k",
    "$100k+",
    "Not sure yet"
]

export const PROJECT_CATEGORIES = ['Brand', 'Campaign', 'Performance'] as const
